import { UnitWallElementFormModel } from '../../quote-or-design-form/units/heatLoss/unitWallElementFormModel';

export type UnitWallElementResponse = {
  wallElementId: number;
  displayIndex: number;
  name: string;
  wallThermalTransmittance: number | null;
  windowThermalTransmittance: number | null;
  doorThermalTransmittance: number | null;
  defaultExternalAirTemperatureInDegreesCelsius: number | null;
};

export const mapUnitWallElementResponseToFormModel = (response: UnitWallElementResponse): UnitWallElementFormModel => ({
  wallElementId: response.wallElementId,
  name: response.name,
  wallThermalTransmittance: response.wallThermalTransmittance?.toString() ?? '',
  windowThermalTransmittance: response.windowThermalTransmittance?.toString() ?? '',
  doorThermalTransmittance: response.doorThermalTransmittance?.toString() ?? '',
  defaultExternalAirTemperatureInDegreesCelsius:
    response.defaultExternalAirTemperatureInDegreesCelsius?.toString() ?? '',
});
